// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1ZgTy","head":"ProcedureTableInfo_head__eBMPe"};